import { createContext, useState, useRef, useEffect } from 'react';
import config from '../../../constants/settings';

export const WebsocketContext = createContext([false, null, () => {}]);

export const WebsocketDrivers = (props) => {
  const { children, filtersOpts, setListDrivers, setLoading, uuid, reloadList, listDrivers } = props;
  const [isReady, setIsReady] = useState(false);
  const ws = useRef(null);
  const filtersSent = useRef(false);

  useEffect(() => {
    if (!uuid) {
      return;
    }

    const encodedSub = encodeURIComponent(uuid);

    const socket = new WebSocket(`${config.api.socketApi}/?x-api-key=${config.api.socketKey}&sub=${encodedSub}&lat=${0.0}&lon=${0.0}`);

    socket.onopen = () => {
      setIsReady(true);
      if (socket.readyState === WebSocket.OPEN) {
        socket.send(JSON.stringify(filtersOpts));
        filtersSent.current = true;
      }
    };

    socket.onclose = () => {
      setIsReady(false);
      filtersSent.current = false;
    };

    socket.onmessage = (event) => {
      const json = JSON.parse(event.data);
      try {
        if (json.event = "data") {
          if (filtersSent.current) {
            setListDrivers(JSON.parse(event.data));
            setLoading(false);
          }
        }
      } catch (err) {
        console.error("Error - OnMessage", err);
      }
    };

    ws.current = socket;

    return () => {
      socket.close();
    };
  }, [uuid]);

  useEffect(() => {
    if (ws.current && isReady && ws.current.readyState === WebSocket.OPEN) {
      ws.current.send(JSON.stringify(filtersOpts));
      filtersSent.current = true;
    }
  }, [filtersOpts, reloadList]);

  const ret = [isReady, listDrivers, ws.current?.send.bind(ws.current)];

  return (
    <WebsocketContext.Provider value={ret}>
      {children}
    </WebsocketContext.Provider>
  );
};
